import React from "react";
import { motion } from "framer-motion";

const events = [
  { year: "Bombay HC", title: "Regular Appearances", desc: "Ongoing practice before the Bombay High Court in criminal, civil, and constitutional matters." },
  { year: "Kolhapur", title: "Bench Practice", desc: "Representation before the Kolhapur Bench with a dedicated satellite chamber at Azad Chowk." },
  { year: "Across India", title: "Across India", desc: "Appearances before subordinate courts, service tribunals and consumer forums across the nation." },
];

export default function Experience() {
  return (
    <section className="py-24 md:py-40 bg-[#0B0B0B]" data-testid="experience-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-24">
        <div className="mb-16 md:mb-20">
          <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white/95">Experience &<br/><span className="italic text-[#C8A45D]/90">representation.</span></h2>
        </div>

        <div className="relative pl-8 md:pl-16">
          <div className="absolute left-0 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#C8A45D]/40 to-transparent" />
          {events.map((e, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="relative pb-16 last:pb-0"
            >
              <div className="absolute -left-[36px] md:-left-[68px] top-2 w-3 h-3 border border-[#C8A45D] bg-[#0B0B0B] rounded-full" />
              <div className="font-cinzel text-[10px] tracking-[0.35em] text-[#C8A45D] mb-3">{e.year}</div>
              <h3 className="font-serif-display text-3xl md:text-4xl text-white/95 mb-3">{e.title}</h3>
              <p className="text-white/55 font-body max-w-2xl text-base leading-relaxed">{e.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
